import getPrType from "./prType";
import PostService from "../services/PostService";
import moment from "moment";

const validPRPublishedAt = async (pr_type, publishedAt, listPosttyle, post) => {
  try{
    const postId = post ? post._id : null;
    const prTypes = getPrType();
    const prType = prTypes.find(
      (el) => el.value != "0" && el.expiredTime && el.value === pr_type && pr_type
    );
    if(!prType || !prType.expiredTime) return null;
      
    const publishedAt_gt = moment(publishedAt)
      .subtract(prType.expiredTime, "hour")
      .toISOString();
    const publishedAt_lt = moment(publishedAt)
      .add(prType.expiredTime, "hour")
      .toISOString();
    const limit = prType.limit ? prType.limit : 1;
    let categories = [];
    if(post.categories){
      post.categories.map(el => {
        categories.push(el._id);
      })
    }
    const prPostsPublished = await PostService.get(
      {
        _limit: { fieldName: "_limit", value: limit },
        pr_type: { fieldName: "pr_type", value: prType.value },
        publishedAt_gt: { fieldName: "publishedAt_gt", value: publishedAt_gt },
        publishedAt_lt: { fieldName: "publishedAt_lt", value: publishedAt_lt },
        posttype_ready: { fieldName: "posttype", value: listPosttyle.find(t => t.type_code === 'ready').id },
        posttype_schedule: { fieldName: "posttype", value: listPosttyle.find(t => t.type_code === 'schedule').id },
        ...(postId &&
          {
            _id: { fieldName: "_id_ne", value: postId },
          }  
        ),
        ...(categories && categories.map(cate => {
          return {
            fieldName: "categories_in", value: cate,
          }
        }))
      },
      false,
      true
    );
    // console.log(prPostsPublished);
    const prPostSchedule = await PostService.get(
      {
        _limit: { fieldName: "_limit", value: limit },
        pr_type: { fieldName: "pr_type", value: prType.value },
        scheduleAt_gt: { fieldName: "scheduleAt_gt", value: publishedAt_gt },
        scheduleAt_lt: { fieldName: "scheduleAt_lt", value: publishedAt_lt },
        posttype_ready: { fieldName: "posttype", value: listPosttyle.find(t => t.type_code === 'ready').id },
        posttype_schedule: { fieldName: "posttype", value: listPosttyle.find(t => t.type_code === 'schedule').id },
        ...(postId &&
          {
            _id: { fieldName: "_id_ne", value: postId },
          }  
        ),
        ...(categories && categories.map(cate => {
          return {
            fieldName: "categories_in", value: cate,
          }
        }))
      },
      false,
      true
    );
    // console.log(prPostSchedule);
    const totals = prPostsPublished.totals + prPostSchedule.totals;
    const prPosts = [
      ...prPostsPublished.posts,
      ...prPostSchedule.posts,
    ]
    // console.log(prPosts);
    if (prPosts && totals && totals >= limit) {
      let messageSecond = `<ul>`;
      prPosts.map((item) => {
        messageSecond += `<li>
          <div>
              <div><a href="/posts/edit/${item.id}" target="_blank">${
          item.title
        }</a></div>
              <div>Đăng lúc: ${moment(
                item.scheduleAt ? item.scheduleAt : item.publishedAt
              ).format("DD-MM-YYYY HH:mm")}</div>
              <div>Hiệu lực: ${moment(
                item.scheduleAt ? item.scheduleAt : item.publishedAt
              )
                .add(prType.expiredTime, "hour")
                .format("DD-MM-YYYY HH:mm")}</div>
          </div>
      </li>`;
      });
      messageSecond += `</ul>`;
      return {
        should_check_condition: "no",
        message: `Bài PR trùng lịch ?`,
        type: "error",
        messageConfirm: "Vui lòng set lại giờ đăng.",
        messageSecond,
      };
    }
  }catch(e){
    console.log(e);
  }
  return null;
};

export default validPRPublishedAt;
